/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";

import {
  handleMpinSetup,
  handleValidatePin,
  handleResetPin
} from "api";

import {
  WealthyEnv,
  WealthyEncrypt,
  handleFuryApiError
} from "helpers";

import PinVerification from "./PinVerification";

const propTypes = {
  authRes: PropTypes.object,
  rsessionId: PropTypes.string,
  setAuthRes: PropTypes.func,
  setIsLoading: PropTypes.func,
  setUserStep: PropTypes.func
};

const PinVerificationContainer = ({
  authRes,
  setAuthRes,
  rsessionId,
  setUserStep,
  setIsLoading
}) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [newPin, setNewPin] = useState("");

  const setCookie = (encryptedToken, expiryTime, accesssTokenExpiry) => {
    Cookies.set("wl_xxid_acc", encryptedToken, {
      expires: expiryTime,
      path: "/",
      domain: WealthyEnv.COOKIE_DOMAIN
    });

    Cookies.set("wl_access_token_expiry", accesssTokenExpiry, {
      path: "/",
      domain: WealthyEnv.COOKIE_DOMAIN
    });
  };

  const setAuthToken = (token, expiry) => {
    const expiryTime = new Date(new Date().getTime() + expiry * 1000);
    const accesssTokenExpiry = Date.now() + expiry * 1000;
    const encryptedToken = WealthyEncrypt.encryptToken(token);
    setCookie(encryptedToken, expiryTime, accesssTokenExpiry);
  };

  const handlePinSetup = async (e) => {
    const pin = e.target.value;

    // Login 
    if (authRes.nextStep === "TWOFA_INPUT") {
      if (pin.length >= 4) {
        setIsLoading(true);

        try {
          const payload = {};
          payload["pin"] = pin;
          const res = await handleValidatePin(payload, rsessionId, authRes.accessToken);
          if (res?.data) {
            setAuthRes(res.data);
            if (res.data.nextStep === "LOGIN_SUCCESS") {
              const token = res.data.accessToken;
              const tokenExpiry = res.data.accessTokenExpiresIn;
              setAuthToken(token, tokenExpiry);
              setUserStep(4);
            }
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        } catch (err) {
          handleFuryApiError (err);
          setIsLoading(false);
        }
      }

    // Signup
    } else if (authRes.nextStep === "TWOFA_SETUP") {
      if (pin.length >= 4) {
        if (newPin.length >= 4) {
          setIsLoading(true);

          try {
            const payload = {};
            payload["pin1"] = newPin;
            payload["pin2"] = pin;
            const res = await handleMpinSetup(payload, rsessionId, authRes.accessToken);
            if (res?.data) {
              setAuthRes(res.data);
              if (res.data.nextStep === "LOGIN_SUCCESS") {
                const token = res.data.accessToken;
                const tokenExpiry = res.data.accessTokenExpiresIn;

                setAuthToken(token, tokenExpiry);
                setUserStep(4);
              }
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
          } catch (err) {
            handleFuryApiError(err);
            setIsLoading(false);
          }
        } else {
          setNewPin(pin);
          e.target.value = "";
          e.target.focus();
        }
      }
    }
  };

  const handleReset = async () => {
    setIsLoading(true);

    try {
      const res = await handleResetPin(authRes.accessToken);
      if (res?.data) {
        window.location.replace(`${WealthyEnv.GATE_WEALTHY_API_URL}/wealthyauth/dashboard/reset-pin/?prt=${res.data?.requestId}&redirect_url=${WealthyEnv.URL}/broking?pinResetSuccessfully`);
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      handleFuryApiError(err);
      setIsLoading(false);
    }
  };

  return (
    <PinVerification
      authRes={authRes}
      handlePinSetup={handlePinSetup}
      handleReset={handleReset}
      isVerifying={isVerifying}
      newPin={newPin}
    />
  );
};

PinVerificationContainer.propTypes = propTypes;

export default PinVerificationContainer;
